import { get } from "lodash"

export function isCaptchaRequired(error) {
  return get(error, "headers.x-omegapoint-captcha-required") === "true"
}
